var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-btn',{attrs:{"large":"","color":"success"},on:{"click":_vm.getReportesByIdEncuestaPregunta}},[_vm._v(" Descargar Resultados "),_c('v-icon',{staticClass:"mr-2"},[_vm._v("download_for_offline")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }